import './App.css';
import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';

import Layout from './components/Layout';
import PrayerTimeLanding from './components/PrayerTimeLanding';
import SuraDashboard from './components/SuraDashboard';

// 🟢 BU: Service Worker update prompt (LmsPromoPrompt DEĞİL!)
// import UpdatePrompt from "./components/UpdatePrompt";

function AppContent({ registerSW }) {
  const location = useLocation();

  const currentUserId =
    location.state?.currentUserId ||
    localStorage.getItem('currentUserId') ||
    'guest';

  const [swRegistration, setSwRegistration] = useState(null);

  useEffect(() => {
    if (registerSW) registerSW(setSwRegistration);
  }, [registerSW]);

  return (
    <>
      <Routes>
        {/* Layout-free pages */}
        <Route path='/prayer-times' element={<PrayerTimeLanding />} />

        {/* 🟢 studentId PARAMETRESİ KALDIRILDI */}
        <Route path='/sura-dashboard' element={<SuraDashboard />} />

        {/* Layout-based pages */}
        <Route element={<Layout currentUserId={currentUserId} />}>
          {/* Home: Layout içindeki isHome === "/" ile PrayerTimeLanding + QuoteSection gösteriliyor */}
          <Route path='/' element={null} />

          {/* Register route şu an kullanılmıyor, placeholder bıraktım */}
          <Route path='/register' element={<Navigate to='/register/abcde' />} />
          {/* <Route path="/register/:code" element={<RegistrationForm />} /> */}

          {/* Eskiden educator dashboard vs. buradaydı, şimdilik yorumda kalabilir */}
        </Route>
      </Routes>

      {/* 🟢 Service worker yeni versiyon prompt'u */}
      {/* {swRegistration && <UpdatePrompt registration={swRegistration} />} */}
    </>
  );
}

export default function App({ registerSW }) {
  return (
    <Router>
      <AppContent registerSW={registerSW} />
    </Router>
  );
}
